import React from 'react';

import { makeStyles, type Theme } from '@material-ui/core';

/*
 *  This wrapper can be used to overwrite the default component styles
 *  without forcing any specificity that might break the flow of the
 *  other styles.
 *
 *  It's recommended to use the styled component whenever it's
 *  necessary to change a pre-defined style.
 *
 *  The use of the <P extends object> is necessary because, on JSX files, Typescript
 *  doesn't know how to infer a generic type.
 */
export const useStyles = (customStyles: object | ((theme: Theme) => void)) =>
  makeStyles(customStyles)();

interface CustomStylesProps {
  customStyles: object | ((theme: Theme) => void);
}

export const applyCustomStyles = <P extends object>(
  Component: React.ComponentType<P>
) =>
  React.memo(({ customStyles, ...otherProps }: P & CustomStylesProps) => {
    const classes = useStyles(customStyles);

    return <Component {...(otherProps as P)} classes={classes} />;
  });
